export const SECTIONS = {
    SOLOPROTECT_MANAGMENT: 'SoloProtect Management',
    CHANNEL_PARTNER: 'Channel Partner',
    USER_MANAGEMENT: 'User Management',
    DEVICE_MANAGEMENT: 'Device Management',
    CONFIGURATION_MANAGEMENT: 'Configuration Management',
    PLATFORM_AUDIT_LOGS: 'Platform Audit Logs',
    REPORTING: 'Reporting',
    HELP_AND_SUPPORT: 'Help & Support',
} as const;